import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useBusinessType from '@/shared/hooks/useBusinessType'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { pageConfigurationActions } from '@/store/PageConfiguration/PageConfigurationSagas'
import {
  selectPageConfigurationData,
  selectPageConfigurationIsLoading,
} from '@/store/PageConfiguration/PageConfigurationSelectors'
import { useTranslation } from 'react-i18next'
import useModal from '@/shared/hooks/useModal'
import { selectSelectedCarbonOffset } from './CarbonOffsetsSelectors'
import { updateSelectedCarbonOffset } from './CarbonOffsetsSlice'
import { useSnackbarNotification } from '@/shared/tools/notifications/useSnackbarNotification'
import { SNACKBAR_TYPES } from '@/shared/tools/notifications/notification'
import { carbonOffsetsActions } from './CarbonOffsetsSagas'

const useCarbonOffsets = () => {
  const dispatch = useDispatch()
  const { loaderRoutesEnergy, loaderRoutes, loaderRoutesInsurance } = useSelector(selectAuthData)
  const { getApplicationUrl } = useBusinessType({
    loaderRoutesEnergy,
    loaderRoutes,
    loaderRoutesInsurance,
    modulesStatuses: {},
    modulesStatusesEnergy: {},
    modulesStatusesInsurance: {},
  })
  const initUrl = getApplicationUrl('carbon-offset')
  const { carbonOffsetProducts } = useSelector(selectPageConfigurationData)
  const isLoading = useSelector(selectPageConfigurationIsLoading)
  const selectedCarbonOffset = useSelector(selectSelectedCarbonOffset)
  const showNotification = useSnackbarNotification()

  const { t } = useTranslation()
  const { isOpen, close, setIsOpen } = useModal()

  const [page, setPage] = useState(1)
  const [carbonOffsetsSearch, setCarbonOffsetsSearch] = useState(carbonOffsetProducts ?? [])
  const setCarbonOffsetHandler = carbonOffsetSearchList => {
    if (carbonOffsetSearchList !== null) {
      setCarbonOffsetsSearch(carbonOffsetSearchList)
    } else {
      setCarbonOffsetsSearch(carbonOffsetProducts)
    }
  }

  const setSelectedCarbonOffset = carbonOffsetData => {
    const attributes = carbonOffsetData?.id ? carbonOffsetData.attributes : {}
    const carbonOffset = {
      id: carbonOffsetData?.id ?? 0,
      name: carbonOffsetData?.id ? carbonOffsetData.name : '',
      price: carbonOffsetData?.id ? attributes.price : '',
      description: carbonOffsetData?.id ? attributes.description : '',
      zoho_id: carbonOffsetData?.id ? carbonOffsetData.zoho_id : '',
      energy_type: carbonOffsetData?.id ? attributes.energy_type : '',
      zoho_prefix: carbonOffsetData?.id ? carbonOffsetData.potential_name : '',
      spb_code: carbonOffsetData?.id ? attributes.spb_code : '',
      tons: carbonOffsetData?.id ? attributes.tons : '',
    }
    dispatch(updateSelectedCarbonOffset(carbonOffset))
    setIsOpen(true)
  }
  const deleteCarbonOffset = carbonOffsetData => {
    if (!carbonOffsetData?.id) return
    if (!window.confirm(t('carbonOffsetConfiguration:delete_confirm'))) return
    const onSuccess = () => {
      setCarbonOffsetsSearch(prev => prev.filter(item => item.id !== carbonOffsetData.id))
      showNotification({ message: t('carbonOffsetConfiguration:delete_success'), kind: 'positive' })
    }
    const onError = errorMessage => {
            showNotification({ message: errorMessage, kind: SNACKBAR_TYPES.ERROR })

      // const translated = errorMessage && errorMessage.includes('carbonOffsetConfiguration:') ? t(errorMessage) : errorMessage
      // showNotification({ message: translated, kind: SNACKBAR_TYPES.ERROR })
    }

    dispatch({
      type: carbonOffsetsActions.DELETE_CARBON_OFFSET,
      id: carbonOffsetData.id,
      onSuccess,
      onError,
    })
  }
  useEffect(() => {
    dispatch({ type: pageConfigurationActions.INITIALIZE, initUrl })
  }, [])

  useEffect(() => {
    if (!carbonOffsetProducts) return
    setCarbonOffsetsSearch(carbonOffsetProducts)
  }, [carbonOffsetProducts])

  return {
    pageConfigurationIsLoading: isLoading,
    t,
    isOpen,
    close,
    setIsOpen,
    page,
    setPage,
    carbonOffsets: carbonOffsetsSearch,
    elementsPerPage: 7,
    setSelectedCarbonOffset,
    selectedCarbonOffset,
    setCarbonOffsetHandler,
    deleteCarbonOffset,
  }
}

export default useCarbonOffsets
